export default {
  interactive_save: '/api/interactive/save',
  interactive_load_user_response: '/api/interactive/load_user_response',
  interactive_load_all: '/api/interactive/load_all',
  interactive_save_user_response: '/api/interactive/save_user_response',
  interactive_clearInteractiveResponse:
    '/api/interactive/clear_interactive_response',
};
